export default {
    FILE_DOWNLOAD_FAILED: ({ error, filleName }) => `Не удалось сохранить ${filleName !== null && filleName !== void 0 ? filleName : "файл"}${error ? `: ${error}` : ""}`,
    FILE_DOWNLOAD_SUCCESS: (filleName) => `${filleName !== null && filleName !== void 0 ? filleName : "Файл"} сохранён в загрузках`
};
